var map = {
	"./": [
		21455,
		9
	],
	"./beryl/Archive": [
		4486,
		9,
		486
	],
	"./beryl/Archive.js": [
		4486,
		9,
		486
	],
	"./coal/Archive": [
		33637,
		9,
		637
	],
	"./coal/Archive.js": [
		33637,
		9,
		637
	],
	"./coal/MaterialInfo": [
		84326,
		9,
		326
	],
	"./coal/MaterialInfo.js": [
		84326,
		9,
		326
	],
	"./coal/Scenarios": [
		88348,
		9,
		348
	],
	"./coal/Scenarios.js": [
		88348,
		9,
		348
	],
	"./default/Archive": [
		65335,
		9,
		335
	],
	"./default/Archive.js": [
		65335,
		9,
		335
	],
	"./default/ExtendedWhereUsedFactors": [
		72234,
		9,
		234
	],
	"./default/ExtendedWhereUsedFactors.js": [
		72234,
		9,
		234
	],
	"./default/FieldsNaming": [
		15764,
		9,
		764
	],
	"./default/FieldsNaming.js": [
		15764,
		9,
		764
	],
	"./default/Logo": [
		89294,
		9,
		294
	],
	"./default/Logo.js": [
		89294,
		9,
		294
	],
	"./default/MaterialInfo": [
		63992,
		9,
		992
	],
	"./default/MaterialInfo.js": [
		63992,
		9,
		992
	],
	"./default/Recommendations": [
		725,
		9,
		725
	],
	"./default/Recommendations.js": [
		725,
		9,
		725
	],
	"./default/Scenarios": [
		39530,
		9,
		530
	],
	"./default/Scenarios.js": [
		39530,
		9,
		530
	],
	"./default/StockingCalculator": [
		82147,
		9,
		147
	],
	"./default/StockingCalculator.js": [
		82147,
		9,
		147
	],
	"./default/messages": [
		91306,
		3,
		306
	],
	"./default/messages.json": [
		91306,
		3,
		306
	],
	"./demo/Archive": [
		24813,
		9,
		813
	],
	"./demo/Archive.js": [
		24813,
		9,
		813
	],
	"./demo/MaterialInfo": [
		68894,
		9,
		894
	],
	"./demo/MaterialInfo.js": [
		68894,
		9,
		894
	],
	"./demo/StockingCalculator": [
		55281,
		9,
		281
	],
	"./demo/StockingCalculator.js": [
		55281,
		9,
		281
	],
	"./gold/Recommendations": [
		66522,
		9,
		522
	],
	"./gold/Recommendations.js": [
		66522,
		9,
		522
	],
	"./gold/messages": [
		62583,
		3,
		583
	],
	"./gold/messages.json": [
		62583,
		3,
		583
	],
	"./index": [
		21455,
		9
	],
	"./index.js": [
		21455,
		9
	],
	"./iron/Archive": [
		58660,
		9,
		660
	],
	"./iron/Archive.js": [
		58660,
		9,
		660
	],
	"./iron/ExtendedWhereUsedFactors": [
		90463,
		9,
		463
	],
	"./iron/ExtendedWhereUsedFactors.js": [
		90463,
		9,
		463
	],
	"./iron/MaterialInfo": [
		19145,
		9,
		145
	],
	"./iron/MaterialInfo.js": [
		19145,
		9,
		145
	],
	"./iron/StockingCalculator": [
		59350,
		9,
		350
	],
	"./iron/StockingCalculator.js": [
		59350,
		9,
		350
	],
	"./wood/Archive": [
		91871,
		9,
		871
	],
	"./wood/Archive.js": [
		91871,
		9,
		871
	],
	"./wood/ExtendedWhereUsedFactors": [
		12930,
		9,
		930
	],
	"./wood/ExtendedWhereUsedFactors.js": [
		12930,
		9,
		930
	],
	"./wood/FieldsNaming": [
		8588,
		9,
		588
	],
	"./wood/FieldsNaming.js": [
		8588,
		9,
		588
	],
	"./wood/Logo": [
		72694,
		9,
		694
	],
	"./wood/Logo.js": [
		72694,
		9,
		694
	],
	"./wood/MaterialInfo": [
		72368,
		9,
		368
	],
	"./wood/MaterialInfo.js": [
		72368,
		9,
		368
	],
	"./wood/StockingCalculator": [
		40875,
		9,
		875
	],
	"./wood/StockingCalculator.js": [
		40875,
		9,
		875
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9813;
module.exports = webpackAsyncContext;